import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Week 10, The myriad virtues of Wavelet Trees",
  "description": "",
  "published": "2013-12-25T00:00:00.000Z",
  "redirect_from": ["/blog/week-10-the-myriad-virtues-of-wavelet-trees/swizec/6468"],
  "categories": "52papers52weeks, Data compression, Entropy, Learning, Numerical Analysis, Personal, Run-length encoding, Wavelet Tree",
  "hero": "./img/images-6200.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`[`}{`This post is part of an ongoing challenge to understand 52 papers in 52 weeks. You can read previous entries, `}<a parentName="em" {...{
          "href": "http://swizec.com/blog/category/52-papers-in-52-weeks"
        }}>{`here`}</a>{`, or subscribe to be notified of new posts by `}<a parentName="em" {...{
          "href": "http://swiz.ec/52papers-list"
        }}>{`email`}</a>{`]`}</em></p>
    <p><a parentName="p" {...{
        "href": "http://www.sciencedirect.com/science/article/pii/S0890540108001594"
      }}>{`The Myriad Virtues of Wavelet Trees`}</a>{` is a 2009 CS paper written by Ferragina, Giancarlo, and Manzini. The holiday cheer the past few days made this one hard to understand and write about ... something about focus.`}</p>
    <p>{`It talks about using Wavelet Trees as a stand-alone `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data_compression",
        "title": "Data compression"
      }}>{`compression algorithm`}</a>{` and as on top of some popular string encodings like run-length encoding, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Move-to-front_transform",
        "title": "Move-to-front transform"
      }}>{`move-to-front transform`}</a>{` and the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Burrows%E2%80%93Wheeler_transform",
        "title": "Burrows–Wheeler transform"
      }}>{`Burrows-Wheeler transform`}</a>{`. The results are pretty cool, but not revolutionary. The authors just improved some additive terms in lower and upper bounds of achievable compression.`}</p>
    <h2 {...{
      "id": "background-knowledge"
    }}>{`Background knowledge`}</h2>
    <p>{`Before we can get into the meat of this paper, you'll need to know about Wavelet Trees and run-length encoding and Burrows-Wheeler and stuff. On my first run-through I didn't pay attention in this section and spent the rest of the paper very confused.`}</p>
    <p><strong parentName="p">{`Wavelet Trees`}</strong>{` recursively partition the source alphabet into pairs of subsets, then mark which branch of the tree a particular symbol goes into. To reconstruct elements at you just walk the tree until you find the leaf and voila, done.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "626px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/b4398b3d08452a6acfa07281f6f5b34b/af590/images-6200.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "78.9237668161435%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'316\\'%20viewBox=\\'0%200%20400%20316\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M109%206c-2%201-1%2054%200%2055l13%201%2011%201-25%2015-24%2015H55l-28%201-1%2027v27l3%201%2016%201h13l-13%2016-12%2015H15v37h3c6%202%2031%201%2032%200%202-1%202-3%202-19v-17l-9-1h-8l5-6%2012-15%208-10h47l12%2015%2013%2016h-8l-8%201-1%2017v18l3%201h33l1-19v-18h-18l-12-15-13-16h30l2-1V94l-28-1c-23%200-27-1-25-2l26-15%2024-14h93l24%2015%2026%2015-19%201-20%201-1%2027c0%2031-1%2029%2011%2029h7l-13%2016-12%2015h-18v37h36l1-19v-17l-9-1h-8l13-15%2013-15%2023-1h23l12%2015%2013%2016h-18l-18%201-1%2027v28h20l-1%202-10%2016-8%2014h-9l-8%201-1%2018v18h37v-36l-9-1c-8%200-9%200-7-3l9-13c10-18%208-16%2026-16%2013%200%2016%200%2017%202l10%2015%209%2015h-8l-8%201v36h36v-37h-18l-9-15-10-16%2010-1h10v-55l-20-1h-19l-12-16-13-15h8c12%200%2011%202%2011-28l-1-26-1-3h-42l-8-5a712%20712%200%2000-31-18l-11-7%2012-1h13V6l-76-1-75%201m1%2027v26h148V7H110v26m83-16c1%201%201%202-1%202s-3%201-3%203l-1%203-1-3c0-2-1-3-3-3l-3%201%202%201c2%200%202%200%200%201-2%200-2%201-2%203%200%201%200%202%208%202%207%200%209%200%208-1l-1-6c0-3-1-5-2-5l-1%202M28%20121v26h111V95H28v26m215%200v26h83V95h-83v26M17%20184v32h33v-33H34l-17%201m100%2016v16h33v-32l-16-1h-17v17m101%200v16h33v-33h-33v17m80%209v26h74v-52h-74v26m37-15c1%201%200%201-1%201-3%200-4%204-3%207%202%202%203%202%208%202l8-1-2-1c-2%200-1-4%202-5l1-1h-8l1%201%201%203-2%202c-2%200-2-1-2-5s0-5-2-5l-1%202m-54%2078l-1%2016v16h34v-33h-16l-17%201m75%2015v17h34l-1-16v-16l-16-1h-17v16\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b4398b3d08452a6acfa07281f6f5b34b/ca0a1/images-6200.webp 223w", "/static/b4398b3d08452a6acfa07281f6f5b34b/75680/images-6200.webp 445w", "/static/b4398b3d08452a6acfa07281f6f5b34b/63b03/images-6200.webp 626w"],
                "sizes": "(max-width: 626px) 100vw, 626px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/b4398b3d08452a6acfa07281f6f5b34b/e92b6/images-6200.png 223w", "/static/b4398b3d08452a6acfa07281f6f5b34b/e66bf/images-6200.png 445w", "/static/b4398b3d08452a6acfa07281f6f5b34b/af590/images-6200.png 626w"],
                "sizes": "(max-width: 626px) 100vw, 626px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/b4398b3d08452a6acfa07281f6f5b34b/af590/images-6200.png",
                "alt": "Wavelet tree for the string \"abracadabra\"",
                "title": "Wavelet tree for the string \"abracadabra\"",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Wavelet tree for the string "abracadabra"`}</figcaption>{`
  `}</figure></p>
    <p>{`Phew, that was simple. Now we just need the transforms.`}</p>
    <p>{`We can do to lower the `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Entropy",
        "title": "Entropy"
      }}>{`entropy`}</a>{` of a string to make it easier to compress. Entropy is a measure of how disorganised our string is. You can also think of it as information density.`}</p>
    <p>{`The paper references two transforms whose aim is to turn a fuzzy string into a string with many runs of the same character: move to front and Burrows-Wheeler transform.`}</p>
    <p><strong parentName="p">{`Move to front transform`}</strong>{` encodes strings into numbers with the help of an indexed alphabet. Every time you replace a character with its index, you move it to the front and re-index. Given a 25-letter English alphabet indexed from `}<inlineCode parentName="p">{`0`}</inlineCode>{` to `}<inlineCode parentName="p">{`25`}</inlineCode>{` the string `}<inlineCode parentName="p">{`bananaaa`}</inlineCode>{` becomes `}<inlineCode parentName="p">{`1,1,13,1,1,1,0,0`}</inlineCode>{`.`}</p>
    <p>{`To reverse the encoding you just re-do the same algorithm again, except replacing indexes with characters.`}</p>
    <p>{`The `}<strong parentName="p">{`Burrows-Wheeler transform`}</strong>{` is a bit more complicated. This one uses sorted rotations of a string. Basically, take all permutations, sort them alphabetically, take the last column.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "610px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/dabd193aaa755609a6ffc4a6f38907dc/5aae9/images-6213.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "42.600896860986545%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'170\\'%20viewBox=\\'0%200%20400%20170\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M229%2025c0%202%200%203%201%202v-1l1-1%201%201c0%203%2016%202%2016%200h1c0%204%204%202%204-1s-2-4-5-2h-1l-2%201c-1%201-2%200-4-1s-2-1-2%202c0%202%200%202-1%200s-3-3-4%200h-1l-2-2c-2-1-2%200-2%202\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/dabd193aaa755609a6ffc4a6f38907dc/ca0a1/images-6213.webp 223w", "/static/dabd193aaa755609a6ffc4a6f38907dc/75680/images-6213.webp 445w", "/static/dabd193aaa755609a6ffc4a6f38907dc/04445/images-6213.webp 610w"],
                "sizes": "(max-width: 610px) 100vw, 610px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/dabd193aaa755609a6ffc4a6f38907dc/e92b6/images-6213.png 223w", "/static/dabd193aaa755609a6ffc4a6f38907dc/e66bf/images-6213.png 445w", "/static/dabd193aaa755609a6ffc4a6f38907dc/5aae9/images-6213.png 610w"],
                "sizes": "(max-width: 610px) 100vw, 610px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/dabd193aaa755609a6ffc4a6f38907dc/5aae9/images-6213.png",
                "alt": "BANANA Burrows-Wheeler transform",
                "title": "BANANA Burrows-Wheeler transform",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`BANANA Burrows-Wheeler transform`}</figcaption>{`
  `}</figure></p>
    <p>{`Reversing a transformed string is simple as well - take the transformed string and sort it. Now you have two columns. Take these pairs of characters and sort them to create more columns. Repeat until you have all the permutations of the original string and take the one where the end-of-file character is last. Voila.`}</p>
    <p>{`After you have a string transformed into a form with less entropy there are a number of things you can do to compress it. For instance, `}<strong parentName="p">{`run-length encoding`}</strong>{` where runs of successive characters are replaced with a count of repetitions and the character. It's not used much on its own anymore, but made a killing compressing simple black&white images back in the day.`}</p>
    <h2 {...{
      "id": "what-were-looking-to-achieve"
    }}>{`What we're looking to achieve`}</h2>
    <p>{`So how can wavelet trees help make all this better?`}</p>
    <p>{`The authors analyse Wavelet Trees as stand-alone compressors and as compressors of run-length encoded strings - `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Run-length_encoding",
        "title": "Run-length encoding"
      }}>{`RLE`}</a>{` Wavelet Trees - and gap encoded string - GE Wavelet Trees. They also show a theoretical justification for Wavelet Trees being better in practice than move-to-front coding.`}</p>
    <p>{`The meat of the article is using Wavelet Trees to compress the output of the Burrows-Wheeler transform and introducing the concept of Generalised Wavelet Trees, which can reach compression almost on the level of theoretical bound for optimal coding even for mixed strings.`}</p>
    <p>{`Ultimately, we're going to beat the theoretical compression limit `}<em parentName="p">{`H0 = -Σi=1h(ni/|s|) log (ni/|s|)`}</em>{` for fixed codewords. Otherwise known as 0-th order entropy. This is the most we can compress a string by always replacing the same symbol with the same codeword.`}</p>
    <p>{`For highly compressible strings this bound doesn't make much sense, so the authors found a better one, `}<em parentName="p">{`H0`}</em>{`*`}{`:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/5c744/images-6217.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "18.385650224215244%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'73\\'%20viewBox=\\'0%200%20400%2073\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M76%209c-1%202-2%204-2%2013%200%208-1%2011-2%2012v4c1%201%202%205%202%2013%200%2010%201%2011%203%2013l3%202-1-3c-2-1-2-3-2-11%200-7%200-10-2-12-2-3-2-4%200-6%202-3%202-6%202-13s0-10%202-12c2-3%200-3-3%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3bdcc1c2bca57ecb6a759e617e6bbadb/ca0a1/images-6217.webp 223w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/75680/images-6217.webp 445w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/8d1ba/images-6217.webp 890w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/b732a/images-6217.webp 1206w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/3bdcc1c2bca57ecb6a759e617e6bbadb/e92b6/images-6217.png 223w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/e66bf/images-6217.png 445w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/4ef49/images-6217.png 890w", "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/5c744/images-6217.png 1206w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/3bdcc1c2bca57ecb6a759e617e6bbadb/4ef49/images-6217.png",
                "alt": "0-th order entropy for highly compressible strings",
                "title": "0-th order entropy for highly compressible strings",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`0-th order entropy for highly compressible strings`}</figcaption>{`
  `}</figure></p>
    <p>{`Our approach is going to beat this by having symbol codewords depend on `}<em parentName="p">{`k`}</em>{` preceding symbols, giving us k-th order entropy of `}<em parentName="p">{`Hk`}</em>{`(s)`}{`*`}{` - the maximum achievable compression by looking at `}<em parentName="p">{`no more than k`}</em>{` preceding symbols.`}</p>
    <h2 {...{
      "id": "achieving-0-th-order-entropy"
    }}>{`Achieving 0-th order entropy`}</h2>
    <p>{`Let `}<em parentName="p">{`CPF`}</em>{` denote a prefix-free encoding with a logarithmic cost of `}<em parentName="p">{`a log n + b`}</em>{` for `}<em parentName="p">{`n ≥ 1`}</em>{`. Codes where `}<em parentName="p">{`a`}</em>{` is higher than 2 wouldn't be very efficient for reasons the paper assumes we understand, so we're only looking at those where `}<em parentName="p">{`a ≤ 2`}</em>{`. This means that `}<em parentName="p">{`b ≥ 1`}</em>{`; for the rest of our discussion we can assume that `}<em parentName="p">{`a ≤ 2b`}</em>{` and `}<em parentName="p">{`a ≤ b+1`}</em>{`.`}</p>
    <p>{`To combine wavelet trees and run length encoding for a string we first define a compressor `}<em parentName="p">{`CRLE(s) = a1CPF(l1)CPF(l2)...`}</em>{`. Which is a fancy way of saying we prefix-encode runs of symbols, but store the first symbol in full.`}</p>
    <p>{`This has a lower bound with a glorious equation, essentially saying that the length of a `}<em parentName="p">{`CRLE(s)`}</em>{` string is the sum of its parts and is shorter than twice the length of `}<em parentName="p">{`s`}</em>{` multiplied by `}<em parentName="p">{`H0`}</em>{`(s)`}{`*`}{` and `}<em parentName="p">{`b+1`}</em>{`.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/eadd10ed513dc9fc97205de01b73b595/eb2ef/images-6221.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "5.381165919282512%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'22\\'%20viewBox=\\'0%200%20400%2022\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/eadd10ed513dc9fc97205de01b73b595/ca0a1/images-6221.webp 223w", "/static/eadd10ed513dc9fc97205de01b73b595/75680/images-6221.webp 445w", "/static/eadd10ed513dc9fc97205de01b73b595/8d1ba/images-6221.webp 890w", "/static/eadd10ed513dc9fc97205de01b73b595/c2b18/images-6221.webp 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/eadd10ed513dc9fc97205de01b73b595/e92b6/images-6221.png 223w", "/static/eadd10ed513dc9fc97205de01b73b595/e66bf/images-6221.png 445w", "/static/eadd10ed513dc9fc97205de01b73b595/4ef49/images-6221.png 890w", "/static/eadd10ed513dc9fc97205de01b73b595/eb2ef/images-6221.png 1324w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/eadd10ed513dc9fc97205de01b73b595/4ef49/images-6221.png",
                "alt": "Length of C<sub>RLE</sub>",
                "title": "Length of C<sub>RLE</sub>",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Length of C<sub>RLE</sub>`}</figcaption>{`
  `}</figure></p>
    <p>{`Now we can combine wavelet trees and run length encoding into 'rle`}<em parentName="p">{`wt', or `}<strong parentName="em">{`RLE Wavelet Trees`}</strong>{`, which first encodes the string with `}{`_`}{`CPF`}</em>{` to make a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Wavelet_Tree",
        "title": "Wavelet Tree"
      }}>{`Wavelet Tree`}</a>{`, then compresses its internal nodes with `}<em parentName="p">{`CRLE`}</em>{`. This produces shorter strings than just `}<em parentName="p">{`CRLE`}</em>{` with a bound of:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/7c1ae9b297864a46428eae8eb63eff0e/6c2de/images-6222.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "5.829596412556054%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'23\\'%20viewBox=\\'0%200%20400%2023\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7c1ae9b297864a46428eae8eb63eff0e/ca0a1/images-6222.webp 223w", "/static/7c1ae9b297864a46428eae8eb63eff0e/75680/images-6222.webp 445w", "/static/7c1ae9b297864a46428eae8eb63eff0e/8d1ba/images-6222.webp 890w", "/static/7c1ae9b297864a46428eae8eb63eff0e/09c32/images-6222.webp 1334w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/7c1ae9b297864a46428eae8eb63eff0e/e92b6/images-6222.png 223w", "/static/7c1ae9b297864a46428eae8eb63eff0e/e66bf/images-6222.png 445w", "/static/7c1ae9b297864a46428eae8eb63eff0e/4ef49/images-6222.png 890w", "/static/7c1ae9b297864a46428eae8eb63eff0e/6c2de/images-6222.png 1334w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/7c1ae9b297864a46428eae8eb63eff0e/4ef49/images-6222.png",
                "alt": "New bound",
                "title": "New bound",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`New bound`}</figcaption>{`
  `}</figure></p>
    <p>{`I'm not entirely certain I understand why this equation says the bound is lower than before, so let's just believe the authors. This produces better compressed strings.`}</p>
    <p>{`For string 'dabbdabc' our algorithm would produce a skewed Wavelet Tree, with 'b' in the left-most leaf since it appears the most.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "824px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/c1c45/images-6223.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "59.19282511210761%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'237\\'%20viewBox=\\'0%200%20400%20237\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9cc91bbd95d7c9c1e21fc30da5bae24/ca0a1/images-6223.webp 223w", "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/75680/images-6223.webp 445w", "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/5758c/images-6223.webp 824w"],
                "sizes": "(max-width: 824px) 100vw, 824px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c9cc91bbd95d7c9c1e21fc30da5bae24/e92b6/images-6223.png 223w", "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/e66bf/images-6223.png 445w", "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/c1c45/images-6223.png 824w"],
                "sizes": "(max-width: 824px) 100vw, 824px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c9cc91bbd95d7c9c1e21fc30da5bae24/c1c45/images-6223.png",
                "alt": "Skewed Wavelet Tree",
                "title": "Skewed Wavelet Tree",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Skewed Wavelet Tree`}</figcaption>{`
  `}</figure></p>
    <p>{`To get GE Wavelet Trees, 'ge`}<em parentName="p">{`wt', we first define a gap encoding called `}{`_`}{`CGap`}</em>{`, which encodes binary strings by noting where 1's are located in the string. This creates a lower bound for compression of:`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/80dcad427afd82d10cd734459d15bbd2/21b4d/images-6224.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "6.278026905829597%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'26\\'%20viewBox=\\'0%200%20400%2026\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/80dcad427afd82d10cd734459d15bbd2/ca0a1/images-6224.webp 223w", "/static/80dcad427afd82d10cd734459d15bbd2/75680/images-6224.webp 445w", "/static/80dcad427afd82d10cd734459d15bbd2/8d1ba/images-6224.webp 890w", "/static/80dcad427afd82d10cd734459d15bbd2/af3f0/images-6224.webp 1280w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/80dcad427afd82d10cd734459d15bbd2/e92b6/images-6224.png 223w", "/static/80dcad427afd82d10cd734459d15bbd2/e66bf/images-6224.png 445w", "/static/80dcad427afd82d10cd734459d15bbd2/4ef49/images-6224.png 890w", "/static/80dcad427afd82d10cd734459d15bbd2/21b4d/images-6224.png 1280w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/80dcad427afd82d10cd734459d15bbd2/4ef49/images-6224.png",
                "alt": "C<sub>Gap</sub> bound",
                "title": "C<sub>Gap</sub> bound",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`C<sub>Gap</sub> bound`}</figcaption>{`
  `}</figure></p>
    <p>{`As with `}<em parentName="p">{`CRLE`}</em>{` before, we make a Wavelet Tree from our string then use `}<em parentName="p">{`CGap`}</em>{` to encode the internal nodes. Because we're just encoding the number of occurrences of a substring between boundaries, we can compress strings very well.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/0288a2a43057d29b8621c5a6c845567e/203d3/images-6225.png",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "5.381165919282512%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'21\\'%20viewBox=\\'0%200%20400%2021\\'%20preserveAspectRatio=\\'none\\'/%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0288a2a43057d29b8621c5a6c845567e/ca0a1/images-6225.webp 223w", "/static/0288a2a43057d29b8621c5a6c845567e/75680/images-6225.webp 445w", "/static/0288a2a43057d29b8621c5a6c845567e/8d1ba/images-6225.webp 890w", "/static/0288a2a43057d29b8621c5a6c845567e/0ee79/images-6225.webp 1322w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/0288a2a43057d29b8621c5a6c845567e/e92b6/images-6225.png 223w", "/static/0288a2a43057d29b8621c5a6c845567e/e66bf/images-6225.png 445w", "/static/0288a2a43057d29b8621c5a6c845567e/4ef49/images-6225.png 890w", "/static/0288a2a43057d29b8621c5a6c845567e/203d3/images-6225.png 1322w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/0288a2a43057d29b8621c5a6c845567e/4ef49/images-6225.png",
                "alt": "ge_wt bound",
                "title": "ge_wt bound",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`ge_wt bound`}</figcaption>{`
  `}</figure></p>
    <h2 {...{
      "id": "rle-wavelet-trees-and-bwt"
    }}>{`RLE wavelet trees and bwt`}</h2>
    <p>{`It turns out that using RLE Wavelet Trees as a post-processor for the Burrows-Wheeler transform, we can achieve that mythical `}<em parentName="p">{`Hk`}</em>{`*`}{` compression. But it doesn't work at all with GE Wavelet Trees.`}</p>
    <p>{`The key is to remember that 'bwt' is a tool for achieving `}<em parentName="p">{`Hk`}</em>{`*`}{` as long as we can achieve `}<em parentName="p">{`H0`}</em>{`*`}{` for every partition. But apparently if we slice the Wavelet Tree according to 'bwt' partitions we get something called a full Wavelet Tree, which doesn't actually improve compression.`}</p>
    <p>{`Instead we have to use pruned Wavelet Trees, which the authors don't really explain. They give a proof that adding Wavelet Trees on top of 'bwt' is beneficial, which I won't try to reproduce here since a large part of it is skipped and put in "the full version".`}</p>
    <p>{`Their final conclusion is that Wavelet Trees act as a sort of compression booster for the Burrows-Wheeler transform, but impose a run-time cost that is non-negligible.`}</p>
    <p>{`Finally, they conclude that GE Wavelet Trees don't work together with 'bwt' because global choices need to be made about things like tree shape and the role of 1's and 0's in nodes. Bummer.`}</p>
    <h2 {...{
      "id": "generalised-wavelet-trees"
    }}>{`Generalised wavelet trees`}</h2>
    <p>{`Three things affect a Wavelet Tree's cost: its binary shape, the assignment of alphabet symbols to leaves, and the possibility of using non-binary compressors for nodes. To address these issues, the authors introduce so called Generalised Wavelet Trees.`}</p>
    <p>{`Let's use two compressors - `}<em parentName="p">{`C01`}</em>{` is specialised for binary strings (RLE for instance), and `}<em parentName="p">{`CΣ`}</em>{` is generic (Huffman coding for instance). We're going to assume they satisfy three properties:`}</p>
    <p>{`a) `}<em parentName="p">{`|C01(x)| ≤ α|x|H0`}</em>{`(x) + β`}{`*`}{` bits for a binary `}<em parentName="p">{`x`}</em>{`, where α and β are constants. b) `}<em parentName="p">{`|CΣ(y)| ≤ |y|H0(y) + η|y| + µ`}</em>{` bits for a generic `}<em parentName="p">{`y`}</em>{`, where η and µ are constants. c) the running time of `}<em parentName="p">{`C01`}</em>{` and `}<em parentName="p">{`CΣ`}</em>{` is a convex function and their working space is non-decreasing`}</p>
    <p>{`Basically we've defined the limit of the longest strings produced by our compressors and decided that we should be able to use them in practice.`}</p>
    <p>{`Now we define a leaf cover, `}<em parentName="p">{`L`}</em>{`, as a subset of nodes in a tree `}<em parentName="p">{`Wp(s)`}</em>{`, if every leaf has a unique ancestor in `}<em parentName="p">{`L`}</em>{`. Then `}<em parentName="p">{`WpL(s)`}</em>{` is the tree with all nodes in `}<em parentName="p">{`L`}</em>{` removed. We colour `}<em parentName="p">{`WpL`}</em>{` with red and black so that leaves are black and all remaining nodes are red.`}</p>
    <p>{`Then we use the binary compressor for all binary strings in `}<em parentName="p">{`WpL`}</em>{` and red stuff, and the generic compressor for non-binary strings and black. As usual we ignore the leaves. Our new cost is the number of bits produced - `}<em parentName="p">{`|C01(s01(u))|`}</em>{` from red nodes and `}<em parentName="p">{`|CΣ(s(u))|`}</em>{` for black nodes.`}</p>
    <p>{`According to the authors, coming up with a way to decode this encoding is trivial, and the whole thing is somehow "better". I don't quite `}<em parentName="p">{`get`}</em>{` why it's better, but I'm probably missing something.`}</p>
    <p>{`There are, however, two optimisation problems with this approach: finding the minimal leaf cover that minimizes the cost function `}<em parentName="p">{`C`}</em>{`(WpL(s))`}{`*`}{`, and finding the optimal combination of Wavelet Tree shape and and assignment of binary and generic compressors to nodes to produce the shortest string possible.`}</p>
    <p>{`They've provided a sketch of the algorithm to solve these, but ultimately a sketch does not a solution make.`}</p>
    <h2 {...{
      "id": "fin"
    }}>{`Fin`}</h2>
    <p>{`So there you have it, Wavelet Trees used for compressing strings after applying the Burrows-Wheeler transform to make it easier. I'm not sure whether this is used anywhere in the real world, but it looks interesting.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=ff41ba4a-6ab1-4920-9eb4-03ac9fad006c",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      